import { TradedFacilityParams } from 'app/models/traded-facilities-params'
import * as types from './types'
import { createReducer } from 'app/state/utils'
export interface TradedFacilityState {
  tradedFacilities: { data: TradedFacilityParams[]; isLoading: boolean }
}

const initialState: TradedFacilityState = {
  tradedFacilities: { data: [], isLoading: false },
}

const tradedFacilitiesReducer = createReducer(initialState)({
  [types.GET_TRADED_FACILITIES]: (state: TradedFacilityState, payload: any) => {
    return {
      ...state,
      tradedFacilities: { data: payload.payload, isLoading: false },
    }
  },
  [types.RESET_TRADED_FACILITIES]: () => {
    return {
      facilityTradedFacilities: { data: [], isLoading: false },
      subTradeTradedFacilities: { data: [], isLoading: false },
      masterTradeTradedFacilities: { data: [], isLoading: false },
      tradedFacilities: { data: [], isLoading: false },
    }
  },
  [types.START_LOADING_TRADED_FACILITIES]: (state: TradedFacilityState) => {
    return {
      ...state,
      tradedFacilities: {
        ...state.tradedFacilities,
        isLoading: true,
      },
    }
  },
  [types.STOP_LOADING_TRADED_FACILITIES]: (state: TradedFacilityState) => {
    return {
      ...state,
      tradedFacilities: {
        ...state.tradedFacilities,
        isLoading: false,
      },
    }
  },
  [types.ADD_TRADED_FACILITY_FEE]: (
    state: TradedFacilityState,
    payload: any,
  ) => {
    const { tradedFacilities } = state
    const allIndex = tradedFacilities.data.findIndex(
      tf =>
        tf.facilityId.id === payload.payload.facilityId.id &&
        tf.contractId?.id === payload.payload.contractId.id,
    )
    const newAllArray = [...tradedFacilities.data]
    newAllArray[allIndex] = { ...payload.payload }

    return {
      ...state,
      tradedFacilities: { data: newAllArray, isLoading: false },
    }
  },
  [types.UPDATE_TRADED_FACILITY_FEE]: (
    state: TradedFacilityState,
    payload: any,
  ) => {
    const { tradedFacilities } = state
    const allIndex = tradedFacilities.data.findIndex(
      tf =>
        tf.facilityId.id === payload.payload.facilityId.id &&
        tf.contractId?.id === payload.payload.contractId.id,
    )
    const newAllArray = [...tradedFacilities.data]
    newAllArray[allIndex] = { ...payload.payload }

    return {
      ...state,
      tradedFacilities: { data: newAllArray, isLoading: false },
    }
  },
  [types.DELETE_TRADED_FACILITY_FEE]: (
    state: TradedFacilityState,
    payload: any,
  ) => {
    if (!payload.payload) {
      return state
    }

    // Find the traded facility matching the payload id
    const index = state.tradedFacilities.data.findIndex(
      tf =>
        tf.contractId?.id === payload.payload.subTradeId &&
        tf.facilityId.id === payload.payload.facilityId,
    )

    // If no matching traded facilities is found, return state as is
    if (index === -1) {
      return state
    }

    const { fees } = state.tradedFacilities.data[index]

    // Filter out fees that match the feeType to be deleted
    const updatedFees = fees.filter(
      (fee: { feeType: string }) => fee.feeType !== payload.payload.feeType,
    )

    // Update the traded facilities array immutably
    const updatedTF = state.tradedFacilities.data.map((tf, i) =>
      i === index ? { ...tf, fees: updatedFees } : tf,
    )

    return {
      ...state,
      tradedFacilities: { data: updatedTF, isLoading: false },
    }
  },
  [types.UPDATE_TRADE_FACILITY_AMOUNT]: (state: any, payload: any) => {
    const newArray = [...state.tradedFacilities.data]
    const { index } = payload.payload

    newArray[index] = {
      ...newArray[index],
      tradeAmount: payload.payload.tradeAmount,
    }

    return {
      ...state,
      tradedFacilities: {
        data: newArray,
        isLoading: false,
      },
    }
  },
  [types.ADD_TEMPORARY_TRADE_FACILITY]: (state: any, payload: any) => {
    const newArray = [...state.tradedFacilities.data]
    const existingIndex = newArray.findIndex(
      (tf: any) =>
        tf.facilityId?.id === payload.payload.facilityId?.id &&
        tf.contractId?.id === payload.payload.subTradeId,
    )
    if (existingIndex >= 0) {
      newArray[existingIndex] = {
        ...newArray[existingIndex],
        tradeAmount: payload.payload.tradeAmount,
      }
    } else {
      newArray.push({
        facilityId: payload.payload.facilityId,
        tradeAmount: payload.payload.tradeAmount,
        contractType: 'SubTradeFacility',
        contractId: {
          admin: payload.payload.facilityId.admin,
          id: payload.payload.subTradeId,
        },
      })
    }

    return {
      ...state,
      tradedFacilities: {
        data: newArray,
        isLoading: false,
      },
    }
  },
  [types.DELETE_TRADED_FACILITIES]: (state: any, payload: any) => {
    const filteredArray = state.tradedFacilities.data.filter(
      (tf: { contractId: { id: any } }) =>
        !(tf.contractId.id === payload.payload.id),
    )

    return {
      ...state,
      tradedFacilities: {
        data: filteredArray,
        isLoading: false,
      },
    }
  },
})

export default tradedFacilitiesReducer
